var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.589,0,0,3.589,0,8c0,4.309,3.425,7.834,7.696,7.994L8.304,16v-0.006C12.575,15.834,16,12.31,16,8 C16,3.589,12.411,0,8,0z M14.777,8c0,3.737-3.04,6.777-6.777,6.777c-3.737,0-6.777-3.04-6.777-6.777 c0-3.737,3.04-6.777,6.777-6.777C11.737,1.223,14.777,4.263,14.777,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,3.759c-1.238,0-2.244,1.007-2.244,2.245c0,0.259,0.211,0.47,0.47,0.47s0.47-0.211,0.47-0.47 C6.696,5.285,7.281,4.7,8,4.7s1.304,0.585,1.304,1.304c0,0.719-0.585,1.304-1.304,1.304c-0.259,0-0.47,0.211-0.47,0.47v1.498 c0,0.259,0.211,0.47,0.47,0.47c0.259,0,0.47-0.211,0.47-0.47V8.199c1.021-0.219,1.774-1.139,1.774-2.195 C10.244,4.766,9.238,3.759,8,3.759z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,10.486c-0.411,0-0.746,0.335-0.746,0.746S7.589,11.978,8,11.978c0.411,0,0.746-0.335,0.746-0.746 S8.411,10.486,8,10.486z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.ff1f74681b5dc2f93ed7e4006ab540a1.svg";
export { ForwardRef as ReactComponent };